// --------------------------------------------------------
// RIGHT ICON - RightIcon
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Cancel, CheckCircle, HelpOutline } from '@mui/icons-material';
import React from 'react'
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// RIGHT ICON INTERFACE
// --------------------------------------------------------

interface IRightIcon {
  value: any;
  hasError: any;
  isOptional?: boolean;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const RightIcon = ({ value, hasError, isOptional = false }: IRightIcon) => {
  // --------------------------------------------------------
  // RIGHT ICON PRIVATE DECLARATIONS
  // --------------------------------------------------------

  const error: any = value !== '' || isOptional ? (hasError !== undefined && value !== '') : hasError !== undefined;
  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      {(error &&
        <Cancel color='error' />
      )}
    </>
  )
  // --------------------------------------------------------
}

export default RightIcon